import { FETCH_SELECTED_MONTH } from '@/store/common/mutation-type'
import { computed, getCurrentInstance, ref } from '@vue/composition-api'

function useSelectMonth () {
    const vm = getCurrentInstance().proxy
    const store = vm.$store

    const selectedMonth = computed(() => store.getters.selectedMonth)
    const months = computed(() => store.getters.months)
    const monthModel = ref(selectedMonth.value)

    // methods
    const handleSelectMonth = (value) => {
        store.commit(FETCH_SELECTED_MONTH, value)
    }

    // initial data
    const selectMonth = (value) => store.commit(FETCH_SELECTED_MONTH, value)

    const setInitialMonthSelect = () => {
        selectMonth(store.getters.months[0])
    }

    const estimatable = computed(() => selectedMonth.value === new Date().toISOString().substring(0, 7))

    return {
        selectMonth,
        setInitialMonthSelect,
        handleSelectMonth,
        selectedMonth,
        monthModel,
        monthOptions: months,
        estimatable
    }
}

export default useSelectMonth
